(() => {
    document.addEventListener("click", (event) => {
        const trigger = event.target.closest('[data-toggle="modal"]');
        if (trigger) {
            const modal = document.querySelector(
                trigger.getAttribute("data-target")
            );
            if (modal) {
                event.preventDefault();
                openModal(modal);
            }
        }

        const closeButton = event.target.closest('[data-dismiss="modal"]');
        if (closeButton) {
            event.preventDefault();
            closeModal(closeButton.closest(".modal"));
        }

        const modalGoLink = event.target.closest(
            "#modal-leave-site-confirmation-go-link"
        );
        if (modalGoLink) {
            closeModal(modalGoLink.closest(".modal"));
        }

        const externalLink = event.target.closest("a.external-site-link");
        if (externalLink && externalLink.id !== "modal-leave-site-confirmation-go-link") {
            const modalButton = document.getElementById(
                "modal-leave-site-confirmation-go-link"
            );

            if (modalButton) {
                modalButton.href = externalLink.href;

                const target = externalLink.getAttribute("target");
                if (target) {
                    modalButton.setAttribute("target", target);
                }
                else {
                    modalButton.removeAttribute("target");
                }

                const rel = externalLink.getAttribute("rel");
                if (rel) {
                    modalButton.setAttribute("rel", rel);
                }
                else {
                    modalButton.removeAttribute("rel");
                }
            }
        }
    });

    function openModal(modal) {
        if (modal.classList.contains("show")) return;

        let backdrop = document.createElement("div");
        backdrop.className = "modal-backdrop fade";
        document.body.appendChild(backdrop);

        requestAnimationFrame(() => backdrop.classList.add("show"));

        document.body.classList.add("modal-open");

        setTimeout(() => {
            modal.classList.add("show");
        }, 150);
    }

    function closeModal(modal) {
        if (!modal.classList.contains("show")) return;

        const iframe = modal.querySelector("iframe");
        if (iframe) {
            if (typeof Vimeo !== "undefined") {
                const vimeoPlayer = new Vimeo.Player(iframe);
                vimeoPlayer.pause();
            }
        }

        modal.classList.remove("show");

        setTimeout(() => {
            const backdrop = document.querySelector(".modal-backdrop");
            if (backdrop) {
                backdrop.classList.remove("show");
                setTimeout(() => backdrop.remove(), 300);
            }
            document.body.classList.remove("modal-open");
        }, 200);
    }

    document.addEventListener("click", (event) => {
        const backdrop = document.querySelector(".modal-backdrop.show");
        if (backdrop && event.target === backdrop) {
            closeModal(document.querySelector(".modal.show"));
        }
    });

    document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
            const modal = document.querySelector(".modal.show");
            if (modal) closeModal(modal);
        }
    });
})();
